(() => {
  const anchors = {'44273973657756':'h1','44468765819036':'h1e','45449568092316':'mini','47022949662876':'lite'};
  const yen = cents => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  const init = root => {
    root.querySelectorAll('[data-jp-product-price]').forEach(block => {
      if (block.dataset.initialized) return;
      const form = document.getElementById(block.dataset.form);
      if (!form) return;
      const salePrices = JSON.parse(block.dataset.salePrices || '{}');
      block.dataset.initialized = 'true';
      form.addEventListener('variant:change', event => {
        const variant = event.detail.variant;
        const finalPrice = salePrices[String(variant?.id)] ?? variant?.price;
        const discount = (variant?.price || 0) - finalPrice;
        block.hidden = !discount;
        const standard = block.parentElement.querySelector('[data-jp-standard-price]');
        if (standard) standard.hidden = !!discount;
        if (!discount) return;
        const referencePrice = variant.price;
        const amount = yen(referencePrice - finalPrice);
        const offer = block.querySelector('.jp-offer-price');
        block.querySelector('[data-reference-label]').textContent = offer.dataset.regularLabel;
        block.querySelector('.original-savings s').textContent = yen(referencePrice);
        block.querySelector('.original-savings strong').textContent = amount + ' OFF';
        const price = block.querySelector('.price');
        if (price.firstChild) price.firstChild.textContent = yen(finalPrice);
        const link = block.querySelector('.jp-pdp-offer__link');
        if (link) link.href = link.dataset.saleRoot + '#' + anchors[String(variant.id)];
      });
    });
  };
  document.addEventListener('cart:error', event => {
    const box = event.target.querySelector('.jp-sale-feedback');
    if (box) box.textContent = event.detail.error;
  });
  document.addEventListener('submit', event => {
    const box = event.target.querySelector('.jp-sale-feedback');
    if (box) box.textContent = '';
  },true);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
